import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { PureDataComponent } from '@aytm/lib/common/components/pure-component'

import '@aytm/lib/rfd-ui/styles/basic/button.scss'

export default class Button extends PureDataComponent {
  static propTypes = {
    /**
     * Button label
     */
    label: PropTypes.string,
    /**
     * is Button disabled
     */
    disabled: PropTypes.bool,
    /**
     * show icon (prop is className)
     */
    icon: PropTypes.string,
    /**
     * icon position: `left` or `right`
     */
    iconPosition: PropTypes.string,
    /**
     * fixed Button width in pixels
     */
    width: PropTypes.number,
    /**
     * Hides left/right paddings
     */
    compact: PropTypes.bool,
    /**
     * string that will be passed to `onAction(action)`
     */
    action: PropTypes.string,
    /**
     * fires when Button is `clicked` and `not disabled`
     */
    onAction: PropTypes.func,
    /**
     * fires when Button is `clicked` (disabled or not)
     */
    onClick: PropTypes.func,
    /**
     * Use `<A>` instead of `<BUTTON>`, prop is `href`
     */
    asAnchor: PropTypes.string,
    /**
     * `target` for `asAnchor`
     */
    target: PropTypes.string,
    /**
     * custom style
     */
    style: PropTypes.object,
    /**
     * custom className
     */
    className: PropTypes.string,
    /**
     * Button theme (adds className `rfd-ui-button-${theme}`)
     */
    theme: PropTypes.string
  }

  static defaultProps = {
    iconPosition: 'right'
  }

  constructor(props) {
    super(props)
    this.onClick = this.onClick.bind(this)
  }

  onClick(event) {
    const { disabled, onAction, onClick, action } = this.props
    if ('function' == typeof onClick) onClick(event) // will fire on any click
    if (!disabled && 'function' == typeof onAction) onAction(action, event) // will fire only if button is enabled
  }

  render() {
    const {
      label,
      disabled,
      compact,
      width,
      icon,
      iconPosition,
      action,
      onAction,
      onClick,
      asAnchor,
      target,
      className,
      style,
      theme,
      ...otherProps
    } = this.props
    const mergedStyle = style ? Object.assign({ width }, style) : { width }
    const buttonProps = {
      className: classNames('rfd-ui-button', className, {
        'rfd-ui-button-disabled': disabled,
        'rfd-ui-button-compact': compact,
        'rfd-ui-button-with-icon': icon && iconPosition != 'left',
        'rfd-ui-button-with-icon-left': icon && 'left' == iconPosition,
        [`rfd-ui-button-theme-${theme}`]: theme
      }),
      style: mergedStyle,
      onClick: this.onClick
    }
    const text = icon ? `${label} <i class='rfd-ui-button-icon ${icon}'></i>` : label
    return asAnchor ? (
      <a {...buttonProps} {...otherProps} href={asAnchor} target={target ? target : '_self'}>
        <span dangerouslySetInnerHTML={{ __html: text }} />
      </a>
    ) : (
      <button {...buttonProps} {...otherProps} dangerouslySetInnerHTML={{ __html: text }} />
    )
  }
}
